import React from 'react';

import { getBrandIconComponent } from 'utils/stripePaymentMethod';

import { IconFrame } from './styled';

type Props = {
  brand: string | null | undefined;
  label?: string;
  width?: number;
};

const PaymentCardBrandIcon: React.FC<Props> = ({
  brand,
  label,
  width = 36,
}) => {
  const BrandIcon = getBrandIconComponent(brand);
  const ariaLabel = label ?? (brand ? `${brand} card` : 'Payment card');

  return (
    <IconFrame aria-label={ariaLabel} role="img" $width={width}>
      <BrandIcon />
    </IconFrame>
  );
};

export default PaymentCardBrandIcon;
